(function () {
  var cardSelector = "[data-combined-listings-card]";
  var optionSelector = "[data-combined-listings-card-option]";
  var productCache = {};

  function debug() {
    try {
      var params = new URLSearchParams(window.location.search);
      var enabled = params.get("combined_listings_debug") === "true" ||
        window.localStorage.getItem("combinedListingsDebug") === "true" ||
        window.Shopify && window.Shopify.designMode;

      if (!enabled) return;
    } catch (error) {
      if (!(window.Shopify && window.Shopify.designMode)) return;
    }

    var args = Array.prototype.slice.call(arguments);
    args.unshift("[CombinedListingsCard]");
    console.log.apply(console, args);
  }

  function normalizeUrl(url) {
    return new URL(url || window.location.pathname, window.location.origin);
  }

  function productJsonUrl(productUrl) {
    var url = normalizeUrl(productUrl);
    var path = url.pathname.replace(/\/$/, "");

    if (!/\.js$/.test(path)) {
      path += ".js";
    }

    return path + url.search;
  }

  function fetchProduct(productUrl) {
    var jsonUrl = productJsonUrl(productUrl);

    if (!productCache[jsonUrl]) {
      productCache[jsonUrl] = fetch(jsonUrl, {
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      }).then(function (response) {
        if (!response.ok) throw new Error("Product JSON fetch failed with status " + response.status);
        return response.json();
      });
    }

    return productCache[jsonUrl];
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? "," : thousands;
    decimal = decimal == null ? "." : decimal;

    if (isNaN(number) || number == null) return "0";

    var parts = (number / 100.0).toFixed(precision).split(".");
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
    var cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  function formatMoney(cents) {
    var format = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : "${{amount}}";
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholder);
    var value = "";

    switch (match && match[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return format.replace(placeholder, value);
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, function (char) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }[char];
    });
  }

  function selectedVariant(product) {
    var available = (product.variants || []).find(function (variant) {
      return variant.available;
    });

    return available || (product.variants || [])[0] || null;
  }

  function imageUrlForWidth(src, width) {
    if (!src) return "";

    try {
      var url = normalizeUrl(src);
      url.searchParams.set("width", width);
      return url.toString();
    } catch (error) {
      return src;
    }
  }

  function updateLinks(card, productUrl, productTitle) {
    Array.prototype.slice.call(card.querySelectorAll("[data-combined-listings-card-link]")).forEach(function (link) {
      link.href = productUrl;
      if (link.classList.contains("product-item__image-link")) {
        link.setAttribute("aria-label", productTitle);
      }
    });

    Array.prototype.slice.call(card.querySelectorAll(".show-product-quickview")).forEach(function (button) {
      button.setAttribute("href", productUrl);
    });
  }

  function updateTitle(card, product) {
    var title = card.querySelector("[data-combined-listings-card-title]");
    if (!title) return;

    title.textContent = product.title;
  }

  function updateImage(card, product) {
    var image = card.querySelector(".product-item__image--one .image__img") ||
      card.querySelector(".product-item__image .image__img");
    var wrapper = image && image.closest(".image");
    var src = product.featured_image || product.images && product.images[0];

    if (!image || !src) return;

    image.src = imageUrlForWidth(src, 700);
    image.srcset = [
      imageUrlForWidth(src, 300) + " 300w",
      imageUrlForWidth(src, 500) + " 500w",
      imageUrlForWidth(src, 700) + " 700w",
      imageUrlForWidth(src, 900) + " 900w"
    ].join(", ");
    image.alt = product.title;

    if (wrapper) {
      wrapper.classList.add("loaded");
    }
  }

  function updateHoverImage(card, product) {
    var image = card.querySelector(".product-item__image--two .image__img");
    var wrapper = image && image.closest(".image");
    var src = product.images && product.images[1];

    if (!image || !src) return;

    image.src = imageUrlForWidth(src, 700);
    image.srcset = [
      imageUrlForWidth(src, 300) + " 300w",
      imageUrlForWidth(src, 500) + " 500w",
      imageUrlForWidth(src, 700) + " 700w",
      imageUrlForWidth(src, 900) + " 900w"
    ].join(", ");
    image.alt = product.title;

    if (wrapper) {
      wrapper.classList.add("loaded");
    }
  }

  function salePercent(price, compareAtPrice) {
    if (!compareAtPrice || compareAtPrice <= price) return "";
    return "-" + Math.round((compareAtPrice - price) * 100 / compareAtPrice) + "%";
  }

  function updatePrice(card, variant) {
    var price = card.querySelector("[data-combined-listings-card-price]");
    if (!price || !variant) return;

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      price.innerHTML = [
        '<span class="visually-hidden">Regular price</span>',
        '<s class="t-subdued">' + formatMoney(variant.compare_at_price) + "</s>",
        '<span class="sale" data-price>' + formatMoney(variant.price) + "</span>",
        '<span class="displayed-discount fs-body-50">' + salePercent(variant.price, variant.compare_at_price) + "</span>"
      ].join(" ");
    } else {
      price.innerHTML = '<span class="product-item__price">' + formatMoney(variant.price) + "</span>";
    }
  }

  function updateSaleBadge(card, variant) {
    var badges = card.querySelector(".product-badges");
    if (!badges || !variant) return;

    var badge = badges.querySelector(".product-badge--sale");
    var label = salePercent(variant.price, variant.compare_at_price);

    if (!label) {
      if (badge) badge.hidden = true;
      return;
    }

    if (!badge) {
      badge = document.createElement("div");
      badge.className = "product-badge product-badge--sale";
      badges.insertBefore(badge, badges.firstChild);
    }

    badge.hidden = false;
    badge.textContent = label;
  }

  function updateRating(card, product) {
    var rating = card.querySelector("[data-combined-listings-card-rating]");
    if (!rating) return;

    rating.setAttribute("data-id", product.id);
  }

  function updatePicker(card, activeButton) {
    Array.prototype.slice.call(card.querySelectorAll(optionSelector)).forEach(function (button) {
      var isActive = button === activeButton;
      button.classList.toggle("selected", isActive);
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  function updateCard(card, button, product) {
    var variant = selectedVariant(product);
    var productUrl = button.getAttribute("data-product-url") || product.url;

    if (!variant) return;

    card.dataset.productCardUrl = productUrl;
    card.dataset.productCardId = product.id;
    card.dataset.productCardHandle = product.handle;

    updateLinks(card, productUrl, product.title);
    updateTitle(card, product);
    updateImage(card, product);
    updateHoverImage(card, product);
    updatePrice(card, variant);
    updateSaleBadge(card, variant);
    updateRating(card, product);
    updatePicker(card, button);

    debug("card updated", {
      productUrl: productUrl,
      productId: product.id,
      variantId: variant.id
    });
  }

  function handleCardOptionClick(event) {
    var button = event.target && event.target.closest(optionSelector);
    if (!button) return;

    var card = button.closest(cardSelector);
    if (!card) return;

    var productUrl = button.getAttribute("data-product-url");
    if (!productUrl || button.classList.contains("selected")) return;

    event.preventDefault();
    event.stopPropagation();

    debug("selected card option", {
      optionValueId: button.getAttribute("data-option-value-id"),
      oldProductUrl: card.dataset.productCardUrl,
      newProductUrl: productUrl
    });

    card.classList.add("combined-listings-card-is-loading");

    fetchProduct(productUrl).then(function (product) {
      updateCard(card, button, product);
    }).catch(function (error) {
      console.error("[CombinedListingsCard] Unable to update product card.", error);
    }).finally(function () {
      card.classList.remove("combined-listings-card-is-loading");
    });
  }

  function init() {
    document.addEventListener("click", handleCardOptionClick);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
